import styled from 'styled-components';

export const InitWrapperStyles = styled.div`
    width: 100%;
    height: 100%;
`;
